import { TextSkeleton } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { type ReactElement } from "react";

export function DocumentDetailsSectionSkeleton(): ReactElement {
  return (
    <Stack spacing={3}>
      <TextSkeleton variant="body1" width="30%" />

      <TextSkeleton variant="body2" width="100%" />
      <TextSkeleton variant="body2" width="100%" />
      <TextSkeleton variant="body2" width="30%" />
    </Stack>
  );
}
